// @flow

const COLLAB_GROUP_TYPE = 'group';
const COLLAB_USER_TYPE = 'user';
const COLLAB_PENDING_TYPE = 'pending';

export { COLLAB_GROUP_TYPE, COLLAB_USER_TYPE, COLLAB_PENDING_TYPE };
